import { RESOURCE_CENTER_PATH } from '@sly/core/constants/dashboardAppPaths';
import React, { useCallback, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import SearchInput from 'sly/system/SearchInput';

const ArticlesSearchContainer = () => {
  const { push } = useHistory();
  const { searchBy } = useParams();

  const [value, setValue] = useState(searchBy || '');

  const onSubmit = useCallback(
    () =>
      value.trim() && push(`${RESOURCE_CENTER_PATH}/search/${value.trim()}`),
    [value]
  );

  return (
    <SearchInput
      placeholder='Search the blog'
      value={value}
      onChange={(evt) => setValue(evt.target.value)}
      onKeyDown={(evt) => evt.keyCode === 13 && onSubmit()}
      className='w-full'
      inputStyles='w-full grow-1'
      buttonStyles='px-s'
      onSubmit={onSubmit}
    />
  );
};

export default ArticlesSearchContainer;
